import PatchOps from '@leverege/api-patch-ops'
import { updateNetwork } from './NetworkActions'

/*
  Usage:
    let updater = NetworkUpdater( dispatch, network )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function NetworkUpdater( dispatch, network, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    dispatch( updateNetwork( network, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = NetworkUpdater;
